<script setup>
    import { computed } from 'vue'

    const props = defineProps({
        value: {
            type: [String, Number],
            required: true,
        },

        min_decimals: {
            type: [String, Number],
            required: false,
            default: 0,
        },

        max_decimals: {
            type: [String, Number],
            required: false,
            default: 0,
        },

        unit: {
            type: String,
            required: false,
            default: '',
        },

        classes: {
            type: String,
            required: false,
            default: '',
        },
    })

    const formattedValue = computed(() => {
        if (props.value && !isNaN(props.value) && props.value !== null && props.value != 0) {
            return (
                new Intl.NumberFormat('cs-CZ', {
                    style: 'decimal',
                    minimumFractionDigits: props.min_decimals,
                    maximumFractionDigits: props.max_decimals,
                }).format(Number(props.value)) +
                ' ' +
                props.unit
            )
        }

        return 0 + ' ' + props.unit
    })
</script>

<template>
    <div :class="classes + ' text-nowrap'">
        {{ formattedValue }}
    </div>
</template>
